import React from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

const Error = props => {
  const {
    intl: { formatMessage }
  } = props

  this.formatMessage = formatMessage

  return <strong>{this.formatMessage(messages.error)}</strong>
}

export default injectIntl(Error)



// WEBPACK FOOTER //
// ./src/components/Error/Error.js